import React from 'react'
import clsx from 'clsx'
import {hasAnyExportFormat, ViewerExportFormat, ViewerExportFormats} from './viewerExport'
import styles from './viewer-export-actions.module.css'

export type ViewerExportActionsProps = {
  /**
   * Formats to offer — controller-allowed intersected with what the iframe implements, via
   * {@link resolveExportFormats}. Empty renders nothing.
   */
  formats: ViewerExportFormats
  onExport: (format: ViewerExportFormat) => void
  className?: string
}

const BUTTONS: Array<{
  format: ViewerExportFormat
  title: string
  iconClass: string
}> = [
  {format: 'png', title: 'Export PNG', iconClass: 'fas fa-file-image'},
  {format: 'pdf', title: 'Export PDF', iconClass: 'fas fa-file-pdf'},
  {format: 'csv', title: 'Export TSV', iconClass: 'fas fa-table'},
]

/**
 * Compact export icon strip for the tab-header reserved slot / grid panel controls.
 */
export const ViewerExportActions: React.FC<ViewerExportActionsProps> = ({
  formats,
  onExport,
  className,
}) => {
  if (!hasAnyExportFormat(formats)) {
    return null
  }

  return (
    <div className={clsx(styles.exportActions, className)} role='group' aria-label='Export'>
      {BUTTONS.map(({format, title, iconClass}) =>
        formats[format] ? (
          <button
            key={format}
            type='button'
            className={styles.exportButton}
            title={title}
            aria-label={title}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              onExport(format)
            }}
            onMouseDown={(e) => {
              // Grid drag handle must not start a drag from export clicks
              e.stopPropagation()
            }}
          >
            <i className={iconClass} aria-hidden='true' />
          </button>
        ) : null
      )}
    </div>
  )
}
